import { render, staticRenderFns } from "./BankDetailsList.vue?vue&type=template&id=4defbc24&"
import script from "./BankDetailsList.vue?vue&type=script&lang=js&"
export * from "./BankDetailsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports